export default class ThingEditDescriptionController {
    /** @ngInject */
    constructor(EventEmitter, $timeout) {
        this.eventEmitter = EventEmitter;
        this.$timeout = $timeout;
    }

    $onChanges({ description }) {
        this.originalDescription = description.currentValue;
    }

    enableEditMode() {
        this.editMode = true;
    }

    disableEditMode() {
        if (this.description !== this.originalDescription) {
            this.onUpdate(
                this.eventEmitter({
                    patch: {
                        description: this.description
                    }
                })
            );
        }
        this.$timeout(() => {
            this.editMode = false;
        });
    }
}



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/thing-details/thing-description/thing-description.controller.js